@if (summary().length) {
  <p
    class="mt-1 flex min-w-0 items-center gap-1 text-xs/4 text-neutral-500"
    data-testid="notification-summary"
  >
    @for (segment of summary(); track $index) {
      @switch (segment.type) {
        @case (SummarySegmentType.ARROW) {
          <i class="ph ph-arrow-right shrink-0"></i>
        }
        @case (SummarySegmentType.DOT) {
          <!-- Two spaces' width either side: the line's 4px gap plus 2px. -->
          <span class="mx-0.5">·</span>
        }
        @case (SummarySegmentType.ID) {
          <ng-container *ngTemplateOutlet="truncatedId; context: { $implicit: segment.text }" />
        }
        @case (SummarySegmentType.COPYABLE_ID) {
          <span>ID:</span>
          <ng-container *ngTemplateOutlet="truncatedId; context: { $implicit: segment.text }" />
          <button
            [cdkCopyToClipboard]="segment.text"
            [showDelay]="TOOLTIP_DEFAULT_DELAY"
            (cdkCopyToClipboardCopied)="onIdCopied($event)"
            class="flx-ds extra-extra-small neutral"
            clickStopPropagation
            pTooltip="Copy ID"
            tooltipPosition="top"
            tooltipStyleClass="flx-prime-tooltip"
            tooltipZIndex="{{ TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX }}"
            flxButton
            icon="center"
            type="button"
            variant="text"
            data-testid="notification-copy-id-button"
            aria-label="Copy ID"
          >
            <i
              [class]="idCopied() ? 'ph-check-circle text-green-300' : 'ph-copy'"
              class="ph"
              flxIcon
            ></i>
          </button>
        }
        @default {
          <span>{{ segment.text }}</span>
        }
      }
    }
  </p>
}

<!-- Cut short on the card; the tooltip and search have it in full. -->
<ng-template
  #truncatedId
  let-id
>
  <span
    [pTooltip]="id"
    [showDelay]="TOOLTIP_DEFAULT_DELAY"
    [showOnEllipsis]="true"
    class="max-w-[7ch] truncate"
    tooltipPosition="top"
    tooltipStyleClass="flx-prime-tooltip"
    tooltipZIndex="{{ TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX }}"
  >
    {{ id }}
  </span>
</ng-template>
